import React from "react";
import Container from "../components/wrapper/container.wrapper";
import * as Servicer from "../modules/servicer";
import {ServicerModuleStoreInterface} from "../types";
import {RouteObject} from "react-router-dom";
import ErrorBoundary from "../components/wrapper/errorBoundary.wrapper";

export const ServicerRouter = ({ isAuthenticated, servicerStore }: {
    isAuthenticated: () => boolean,
    servicerStore:  ServicerModuleStoreInterface
}): RouteObject => (
    {
        path: "/",
        element: <Container/>,
        children: [
            {
                path: "/servicer",
                element: <Servicer.List />,
                errorElement: <ErrorBoundary hasError={true} />,
            },
            {
                path: "/servicer/:id/edit",
                element: <Servicer.Edit />,
                errorElement: <ErrorBoundary hasError={true} />,
                loader: async ({params}: any) => {
                    if (!isAuthenticated()) {
                        return new Promise((reject) => {
                            reject(null)
                        })
                    }

                    return servicerStore.prepareEditForm({ id: params.id });
                },
            },
            {
                path: "/servicer/add",
                element: <Servicer.Add />,
                errorElement: <ErrorBoundary hasError={true} />,
                loader: async () => {
                    if (!isAuthenticated()) {
                        return new Promise((reject) => {
                            reject(null)
                        })
                    }

                    return servicerStore.prepareAddForm();
                },
            },
            {
                path: "/servicer/:id/view",
                element: <Servicer.View />,
                errorElement: <ErrorBoundary hasError={true} />,
                loader: async ({params}: any) => {
                    if (!isAuthenticated()) {
                        return new Promise((reject) => {
                            reject(null)
                        })
                    }

                    return servicerStore.view({ id: params.id });
                },
            },
            {
                path: "/servicer/:id/view_history",
                element: <Servicer.ViewHistory />,
                errorElement: <ErrorBoundary hasError={true} />,
                loader: async ({params}: any) => {
                    if (!isAuthenticated()) {
                        return new Promise((reject) => {
                            reject(null)
                        })
                    }

                    return servicerStore.viewHistory({ id: params.id });
                },
            },
            {
                path: "/servicer/:id/agency_list",
                errorElement: <ErrorBoundary hasError={true} />,
                element: <Servicer.ViewAgencies />,
            },
        ]
    }
)